import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from '@/pages/quickform.vue'
import apiService from '@/services/api.service';
import { pinia } from '@/store';
import i18n from '@/config/i18n';
import SetupCalendar from 'v-calendar';


apiService.init();
const router = createRouter({
    history: createWebHistory(''),
    routes: [],
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    }
})

const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(SetupCalendar);

app.mount('#quickform')
